import React from "react";
import { ContrastChecker } from "./contrastChecker.js";

// Default values for accessibility checks
const DEFAULT_FONT_SIZE = 16;
const DEFAULT_FONT_WEIGHT = 400;

// Accessibility warning component
export function AccessibilityWarning({
  textColor,
  backgroundColor,
  fontSize,
  fontWeight,
  fieldName,
  overlayEnabled,
  overlayColor
}) {
  const [warning, setWarning] = React.useState(null);

  React.useEffect(() => {
    // Determine effective background color: use overlay color if overlay is enabled, otherwise use backgroundColor
    const effectiveBgColor =
      overlayEnabled && overlayColor ? overlayColor : backgroundColor;

    if (textColor && effectiveBgColor) {
      const result = ContrastChecker.checkWCAG(
        textColor,
        effectiveBgColor,
        fontSize || DEFAULT_FONT_SIZE,
        fontWeight || DEFAULT_FONT_WEIGHT
      );
      if (!result.aa) {
        setWarning({
          level: "error",
          message: `Low contrast (${result.ratio}:1). WCAG AA requires ${
            result.isLargeText ? "3:1" : "4.5:1"
          } for ${fieldName || "text"}.`
        });
      } else if (!result.aaa) {
        setWarning({
          level: "warning",
          message: `Contrast ${result.ratio}:1 meets AA but not AAA (requires ${
            result.isLargeText ? "4.5:1" : "7:1"
          }).`
        });
      } else {
        setWarning(null);
      }
    } else {
      setWarning(null);
    }
  }, [
    textColor,
    backgroundColor,
    fontSize,
    fontWeight,
    fieldName,
    overlayEnabled,
    overlayColor
  ]);

  if (!warning) return null;

  return React.createElement(
    "div",
    {
      className: `alert alert-${
        warning.level === "error" ? "danger" : "warning"
      } mt-2 mb-2`,
      style: {
        fontSize: "0.875rem",
        padding: "0.5rem 0.75rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
      }
    },
    React.createElement("i", {
      className: `fas fa-${
        warning.level === "error" ? "exclamation-triangle" : "info-circle"
      }`
    }),
    React.createElement("span", {}, warning.message)
  );
}
